import { createSelector } from 'reselect';
import { LensAddOnVariantStepContainer } from '../../../../steps/LensAddOnVariantStep/LensAddOnVariantStepContainer.js';
import '../../../add-to-cart/selectors.js';
import '../../../bundles/selectors.js';
import '../../../bundles/reducer.js';
import { getSelectedAddOn } from '../../selectors.js';
import '../../reducer.js';
import '../../../products/selectors.js';
import '../../../products/reducer.js';

const lensAddOnVariantStep = {
    stepStatus: createSelector(getSelectedAddOn, (selectedAddOn)=>{
        var ref;
        return Number(selectedAddOn === null || selectedAddOn === void 0 ? void 0 : (ref = selectedAddOn.variants) === null || ref === void 0 ? void 0 : ref.length) > 1 ? 'sub-step' : 'hidden';
    }),
    view: LensAddOnVariantStepContainer
};

export { lensAddOnVariantStep };
//# sourceMappingURL=lens-add-on-variant.js.map
